export default "__VITE_ASSET__C$rcAEee__"